import { AppCommonProps } from 'types/app'
import React from 'react'
import { withI18n } from '~/hocs'
import CreatorServices from '~/services/CreatorServices'
import { useSession } from 'next-auth/react'

const handleClickFbutton = async (creator_id: number) => {
    const { endpoint, path, query } = getURL(location.href);
    await getDeeplink(endpoint + path + query, creator_id).then(function ({ deeplink }: any) {
        if (deeplink != null) {
            const baseURL = 'https://www.facebook.com/sharer/sharer.php';
            window.open(baseURL + '?u=' + encodeURIComponent(deeplink) + '', 'fbwindow', 'width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1');
        }
        return deeplink;
    });
}

const handleClickTwbutton = async (creator_id: number) => {
    const { endpoint, path, query } = getURL(location.href);
    await getDeeplink(endpoint + path + query, creator_id).then(function ({ deeplink }: any) {
        if (deeplink != null) {
            const baseURL = 'https://twitter.com/intent/tweet';
            const affText = 'を写真ACでチェック！';
            window.open(baseURL + '?url=' + encodeURIComponent(deeplink) + '&text=' + encodeURI(affText), 'tweetwindow', 'width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1');
        }
        return deeplink;
    });
}

const handleClickHbbutton = async (creator_id: number) => {
    const { endpoint, path, query } = getURL(location.href);
    await getDeeplink(endpoint + path + query, creator_id).then(function ({ deeplink }: any) {
        if (deeplink != null) {
            const baseURL = 'https://b.hatena.ne.jp/add';
            const affText = 'を写真ACでチェック！';
            window.open(baseURL + '?mode=confirm&url=' + encodeURIComponent(deeplink) + '&title=' + encodeURI(affText), 'tweetwindow', 'width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1');
        }
        return deeplink;
    });
}

const handleClickBlbutton = async (creator_id: number) => {
    const { endpoint, path, query } = getURL(location.href);
    await getDeeplink(endpoint + path + query, creator_id).then(function ({ deeplink }: any) {
        if (deeplink != null) {
            const affText = 'を写真ACでチェック！';
            const link = '<a href="' + deeplink + '" target="_blank" />' + affText + '</a>';
            $('#ac-assoc-blog-value').val(link);
            $('#ac-associate-blog-modal').modal('show');
            //window.open(baseURL + '?url=' + encodeURIComponent(deeplink) + '', 'tweetwindow', 'width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1');
        }
        return deeplink;
    });
}

const handleClickAmbutton = async (creator_id: number) => {
    const { endpoint, path, query } = getURL(location.href);
    await getDeeplink(endpoint + path + query, creator_id).then(function ({ deeplink }: any) {
        if (deeplink != null) {
            const baseURL = 'http://blog.ameba.jp/ucs/entry/srventryinsertinput.do';
            const affText = 'を写真ACでチェック！';
            const amContent = '<a href="' + deeplink + '" target="_blank">' + affText + '</a>';
            window.open(baseURL + '?entry_text=' + encodeURIComponent(amContent), 'tweetwindow', 'width=650, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1');
        }
        return deeplink;
    });
}

const getDeeplink = async (url: string, creator_id: number): Promise<any> => {
    try {
        return await CreatorServices.creatorAssociateGetDeeplink({ url, creator_id}).then((res) => {
            return res.data?.status === 'success' ? res.data?.data : null;
        });
    } catch (e) {
        alert('エラー');
        throw e;
    }
}

const getURL = (url: string) => {
    const urlObj = new URL(url);
    const endpoint = urlObj.origin;
    const path = urlObj.pathname || '/';
    const params = new URLSearchParams(urlObj.search);
    const query = params.toString() || '';
    return { endpoint, path, query };
}

const AssociateToolbar = ({ }: AppCommonProps) => {
    const { data: session } = useSession();
    return (
        <div className="bg-dark">
            <div className="ac-py-1 text-white format-container">
                <div className="container">
                    <div className="ac-d-md-flex align-items-center justify-content-between">
                        <p className="ac-mb-1 ac-mb-md-0">ACアソシエイトツールバー</p>
                        <div className="d-flex align-items-center flex-wrap">
                            <p className="ac-mr-1 ac-mb-md-0">シェア </p>
                            <a id="ac-associate-fb" onClick={(e) => handleClickFbutton(session?.user?.creatorId || 0 )} className="ac-btn ac-btn-secondary ac-mr-1 ac-mb-1 ac-mb-md-0" href="javascript:void(0)"><i className="fab fa-facebook-f"></i></a>
                            <a id="ac-associate-tw" onClick={(e) => handleClickTwbutton(session?.user?.creatorId || 0 )} className="ac-btn ac-btn-secondary ac-mr-1 ac-mb-1 ac-mb-md-0" href="javascript:void(0)"><i className="fab fa-twitter"></i></a>
                            <a id="ac-associate-hb" onClick={(e) => handleClickHbbutton(session?.user?.creatorId || 0 )} className="ac-btn ac-btn-secondary ac-mr-1 ac-mb-1 ac-mb-md-0" href="javascript:void(0)">
                                <img width="15" className="d-block ac-mx-0 lazy loaded" src="/hatena.svg" data-ll-status="loaded" />
                            </a>
                            <a id="ac-associate-am" onClick={(e) => handleClickAmbutton(session?.user?.creatorId || 0 )} className="ac-btn ac-btn-secondary ac-mr-1 ac-mb-1 ac-mb-md-0" href="javascript:void(0)"><i className="fab fa-ameba" >ameba</i></a>
                            <a id="ac-associate-bl" onClick={(e) => handleClickBlbutton(session?.user?.creatorId || 0 )} className="ac-btn ac-btn-secondary ac-mb-1 ac-mb-md-0" href="javascript:void(0)"><small className="text-decoration-none">ブログ</small></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal ac-modal fade" id="ac-associate-blog-modal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header d-block border-0 ac-p-2 bg-e6e6e6">
                            <h5 class="modal-title text-center ac-mr-2">ブログリンク</h5>
                            <button type="button" class="close shadow-none outline-0" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p class="ac-mb-1">下記コードをWebサイトやブログに貼り付けると、このページを宣伝することができます。</p>
                            <input id="ac-assoc-blog-value" class="form-control ac-form-control" onfocus="this.select()" type="text" value="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default withI18n(AssociateToolbar)
